// extracted by mini-css-extract-plugin
export var alertIcon = "_qa-0";